﻿import { Fancybox } from '@fancyapps/ui'
import sal from 'sal.js'

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

import { initNav } from './navigation'
import { initSlideshow } from './slideshow'
import { initTabsPage } from './tabs-pages'
import { initFilters } from './filters'
import { initForms } from './forms'
import { initFarm } from './digital-farm'
import { initQuizPage } from './quiz-page'
import { initPrintFunctions } from './print'

//react
import {renderMemory} from './Game/Memory/MemoryGame';

if(document.getElementById("memoryContainer")){
    renderMemory();
}

// Initialise sal
sal({
  threshold: 0.05,
  once: false,
  root: undefined
})

// Initialise alpine
Alpine.plugin(collapse)
Alpine.start()

const initFancyBox = () => {
    // Initialize fancybox
    Fancybox.bind("[data-fancybox]", {
        mainClass: 'fancybox-item-popup',
        autoFocus: false,
        hideScrollbar: false
    })

    // Calendar popup
    Fancybox.bind("[calendar-fancybox]", {
        mainClass: 'calendar-item-popup',
        closeButton: '',
        hideScrollbar: false
    })
}

window.addEventListener("DOMContentLoaded", () => {
    initFancyBox()

    if (document.querySelectorAll('.mix')) {
        initFilters()
    }

    if (document.querySelectorAll('.tabs-page__article').length > 0 || document.querySelectorAll('.tabs-page__nav-item').length > 0) {
        initTabsPage()
    }

    if (document.getElementsByClassName('carousel').length > 0) {
        initSlideshow()
    }

    if (document.querySelectorAll('form').length > 0 && document.querySelectorAll('.block__forms').length > 0)
    {
        initForms()
    }

    if (document.querySelector('#PageDigitalFarm'))
    {
        initFarm()  
    }

    initPrintFunctions()
})

if (document.querySelector('#PageQuiz'))
{
    initQuizPage()
}

// map functioon

import $ from "jquery";

if(document.querySelectorAll('.map-block'))
{

  if($(window).width() < 920)
  {

    $(".hover-region").on('click',(function(e) {
     $("#info-box").css("display", "block");
      
      $("#info-box").html($(this).data("info"));
      $("#info-box").css("top", e.pageY - $("#info-box").height() - 10);
      $("#info-box").css("left", e.pageX - $("#info-box").width() / 2);
      $("#info-box").css("padding-left", "0px");
     
    }));
    
 
    
    $(".hover-region")
.click(function(e) {
     
       
      })

      $(".left-region").click(function() {
        $("#leftregionText").parent().css("padding-left", "25px");
      })
  
    $(".hover-region").click(function() {
      $('#closeButton').on('click', function() { 
          $('#info-box').toggle(); 
      });
  });
  }
  else
  {
    $(".hover-region").hover(function(e) {
      $("#info-box").css("display", "block");
      $("#info-box").html($(this).data("info"));
    
    });
    
    $(".hover-region").mouseleave(function(e) {
      $("#info-box").css("display", "none");
    });
    
    $(document)
      .mousemove(function(e) {
        $("#info-box").css("top", e.pageY - $("#info-box").height() - 10);
        $("#info-box").css("left", e.pageX - $("#info-box").width() / 2);
      
    })
    .mouseover();
  

  }
}